var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinterestIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_744_6522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.4453 57.2215C44.083 64.3541 42.4228 71.1915 37.4994 74.7631C35.9817 63.9838 39.7293 55.8902 41.4723 47.2969C38.5017 42.2983 41.8298 32.2442 48.0896 34.7228C55.7946 37.7685 41.418 53.2977 51.068 55.2402C61.1454 57.2629 65.2582 37.7582 59.0087 31.4154C49.9828 22.2523 32.7313 31.2005 34.8551 44.3184C35.3705 47.5248 38.683 48.496 36.1785 52.9222C30.4004 51.6428 28.6755 47.0845 28.8982 41.0085C29.2557 31.0632 37.8309 24.1041 46.4346 23.138C57.3149 21.9182 67.527 27.1343 68.9385 37.3671C70.5261 48.9207 64.028 61.4353 52.3915 60.534C49.2369 60.2879 47.9161 58.7236 45.4453 57.2215Z",
    fill: "#EC1C2E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.2449 48C94.2449 73.5403 73.5404 94.2448 48.0001 94.2448C22.4598 94.2448 1.75525 73.5403 1.75525 48C1.75525 22.4597 22.4598 1.75519 48.0001 1.75519C73.5404 1.75519 94.2449 22.4597 94.2449 48Z",
    stroke: "#EC1C2E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_744_6522"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.7986,
    height: 51.7986,
    fill: "white",
    transform: "translate(23.1083 22.9644)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterestIcon);
export default __webpack_public_path__ + "static/media/pinterestIcon.6970f602d141474d20390618d252250a.svg";
export { ForwardRef as ReactComponent };